// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#aw--c #aw-sl .wc[data-v-0663bfbe]{padding:0!important;max-width:unset!important;width:100%!important;margin:0!important}", ""]);
// Exports
module.exports = exports;
